import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {Platform} from '@ionic/angular';
import {Observable, from} from 'rxjs';
import {tap} from 'rxjs/operators';
import {NativeStorageProxy} from './native-storage-proxy.service';

@Injectable({
  providedIn: 'root'
})

export class ApiUrlService {
  private _apiUrl: string;

  constructor(
    private platform: Platform,
    private nativeStorage: NativeStorageProxy,
  ) {
  }

  get apiUrl() {
    if (!this._apiUrl) {
      this.apiUrl = this.initialUrl
    }
    return this._apiUrl;
  }

  set apiUrl(newUrl: string) {
    this._apiUrl = newUrl;
    this.platform.ready().then(() => this.nativeStorage.setItem('api:api-url', this._apiUrl));
  }

  get initialUrl() {
    return environment.initialApiUrl == undefined ? `${location.protocol}//${location.host}` : environment.initialApiUrl;
  }

  loadApiUrl(): Observable<string> {
    this.nativeStorage.create();
    const apiUrlPromise = this.nativeStorage.getItem('api:api-url', this.initialUrl);
    return from(apiUrlPromise).pipe(tap(url => (this._apiUrl = url)));
  }
}
